var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.302 4.133a.877.877 0 0 1-.884.871H4.062a.29.29 0 0 0-.295.29V19.23c0 .16.132.29.295.29h8.356c.488 0 .884.39.884.871s-.396.871-.884.871H4.062C2.923 21.262 2 20.352 2 19.23V5.295c0-1.123.923-2.033 2.062-2.033h8.356c.488 0 .884.39.884.871",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.446 10.797c0-.598.464-1.096 1.067-1.148 2.065-.179 4.14-.21 6.21-.094q.023-.43.056-.86l.128-1.73c.049-.667.803-1.04 1.375-.68a18.2 18.2 0 0 1 5.017 4.683l.505.693c.262.36.262.843 0 1.203l-.505.693a18.2 18.2 0 0 1-5.017 4.683c-.572.36-1.326-.013-1.375-.68l-.128-1.73q-.032-.43-.056-.86a44 44 0 0 1-6.21-.094 1.16 1.16 0 0 1-1.067-1.148z",
  clipRule: "evenodd"
})));
export default SvgLog;